// src/pages/customer/Login.jsx
import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useAuth } from "../../context/AuthContext";
import Spinner from "../../components/common/Spinner";
import toast from "react-hot-toast";
import { FiMail, FiLock, FiEye, FiEyeOff } from "react-icons/fi";
import logo from "../../assests/logo.png";

export default function Login() {
  const { login } = useAuth();
  const navigate  = useNavigate();
  const location  = useLocation();
  const from = location.state?.from?.pathname || "/";
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { register, handleSubmit, formState: { errors } } = useForm();

  const onSubmit = async ({ email, password }) => {
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      navigate(from, { replace: true });
    } catch (err) {
      toast.error(err.code === "auth/invalid-credential" ? "Invalid email or password" : "Login failed. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-200px)] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">

        {/* Header */}
       
        {/* Card */}
        <div className="card p-7">
            <h1 className="text-2xl font-bold text-gray-900">
  Welcome Back
</h1>

<p className="text-gray-500 mt-2 text-sm  mb-4">
  Sign in to access fresh agricultural products and manage your orders.
</p>
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">

            {/* Email */}
            <div>
              <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">
                Email address
              </label>
              <div className="relative">
                <FiMail className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4 pointer-events-none" />
                <input
                  {...register("email", {
                    required: "Email is required",
                    pattern: { value: /^\S+@\S+$/, message: "Invalid email" },
                  })}
                  type="email"
                  placeholder="you@example.com"
                  className={`w-full rounded-xl border bg-gray-50 text-sm text-gray-900 placeholder-gray-400
                    pl-9 pr-3 py-2.5 outline-none transition-all
                    focus:bg-white focus:border-primary-400 focus:ring-2 focus:ring-primary-100
                    hover:border-gray-300
                    ${errors.email ? "border-red-300 bg-red-50 focus:border-red-400 focus:ring-red-100" : "border-gray-200"}`}
                />
              </div>
              {errors.email && (
                <p className="text-xs text-red-500 mt-1">⚠ {errors.email.message}</p>
              )}
            </div>

            {/* Password */}
            <div>
              <div className="flex justify-between items-center mb-1.5">
                <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide">
                  Password
                </label>
                <Link to="/forgot-password" className="text-xs text-primary-600 hover:underline font-medium">
                  Forgot password?
                </Link>
              </div>
              <div className="relative">
                <FiLock className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4 pointer-events-none" />
                <input
                  {...register("password", { required: "Password is required" })}
                  type={showPassword ? "text" : "password"}
                  placeholder="••••••••"
                  className={`w-full rounded-xl border bg-gray-50 text-sm text-gray-900 placeholder-gray-400
                    pl-9 pr-10 py-2.5 outline-none transition-all
                    focus:bg-white focus:border-primary-400 focus:ring-2 focus:ring-primary-100
                    hover:border-gray-300
                    ${errors.password ? "border-red-300 bg-red-50 focus:border-red-400 focus:ring-red-100" : "border-gray-200"}`}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? <FiEyeOff className="w-4 h-4" /> : <FiEye className="w-4 h-4" />}
                </button>
              </div>
              {errors.password && (
                <p className="text-xs text-red-500 mt-1">⚠ {errors.password.message}</p>
              )}
            </div>

            {/* Submit */}
            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full flex items-center justify-center gap-2 py-2.5 rounded-xl font-semibold text-sm mt-2 disabled:opacity-70 disabled:cursor-not-allowed"
            >
              {loading ? <><Spinner size="sm" /> Signing in...</> : "Sign In"}
            </button>
          </form>

          <p className="text-center text-sm text-gray-600 mt-5">
            Don't have an account?{" "}
            <Link to="/register" className="text-primary-600 font-medium hover:underline">
              Register
            </Link>
          </p>
        </div>

      </div>
    </div>
  );
}